import React from "react";
import { BonusFromSource } from "../../interfaces/BonusFromSource";
import { BonusSourceDetails } from "../../interfaces/BonusSourceDetails";
import { RuleItem } from "../../interfaces/RuleItem";
import SourcesSelection from "./SourcesSelection";
import Drawer from "../Drawer";
import { RuleModuleContext } from "../../contexts/RuleModuleContext";
import { BonusDetail } from "../../interfaces/BonusDetail";
import { Button } from "@material-ui/core";

interface Props {
  open: boolean;
  bonusSourceDetails: BonusSourceDetails;
  formKey: string;

  onClickCancelEdit(): void;
}

export default ({
  open,
  bonusSourceDetails,
  formKey,
  onClickCancelEdit,
}: Props) => {
  const { updateItemDefinition } = React.useContext(RuleModuleContext);
  const [bonusSources, setBonusSources] = React.useState<string[]>(
    bonusSourceDetails.bonusesFromSources.map(
      (bonusDetails: BonusDetail) => bonusDetails.sourceKey
    )
  );

  const updateRuleItemAndClose = () => {
    const bonuses: BonusFromSource[] = bonusSources.map((item: string) => {
      return { source: item };
    });
    const updatedRuleItem: RuleItem = {
      name: bonusSourceDetails.actualBonus.sourceName,
      key: bonusSourceDetails.actualBonus.sourceKey,
      details: { bonusCalculator: { sources: bonuses } },
    };
    updateItemDefinition(updatedRuleItem);
    onClickCancelEdit();
  };

  return (
    <Drawer DrawerProps={{ open, onClose: onClickCancelEdit }}>
      <SourcesSelection
        bonusSources={bonusSources}
        ruleItemKey={bonusSourceDetails.actualBonus.sourceKey}
        addOrUpdateBonusSources={setBonusSources}
      />
      <Button
        color="primary"
        variant="contained"
        data-test={`save-and-close-${formKey}`}
        onClick={updateRuleItemAndClose}
      >
        Save And Close
      </Button>
    </Drawer>
  );
};
